import { Controller } from "stimulus"
import { delay, memoize, nextFrame } from "../helpers"

export default class extends Controller {
  static values = {
    url: String,
    updates: Number,
    completed: Boolean,
    autoscroll: Boolean,
  }

  initialize() {
    this.update()
  }

  // Private

  async update() {
    if (this.completedValue) return
    if (this.updatesValue > 35) return

    await nextFrame()
    const data = await this.queue.push(this.fetch)
    if (!data) return

    this.render(data.html)
    this.completedValue = data.completed
    this.updatesValue++
    this.update()
  }

  fetch = async (url = this.urlValue) => {
    const headers = { Accept: "application/json" }
    const response = await fetch(url, { headers })
    if (response.ok) return await response.json()
  }

  async render(html) {
    if (!html) return
    await nextFrame()
    this.html = html
  }

  set html(html) {
    if (html == this.html) return
    this.element.innerHTML = html
    if (!this.autoscrollValue) return
    this.element.scrollIntoView({ block: "end" })
  }

  get html() {
    return this.element.innerHTML
  }

  get queue() {
    return JitterQueue.instance
  }
}

class JitterQueue {
  static get instance() {
    return memoize(this, "instance", new this())
  }

  jitter = [500, 1500]
  #queue = []

  push(fn) {
    return new Promise((resolve) => {
      this.#queue.push(async () => resolve(await fn()))
      queueMicrotask(() => this.process())
    })
  }

  async process() {
    if (this.processing) return

    const fn = this.#queue.shift()
    if (!fn) return

    this.processing = true
    await delay(this.random())
    await fn().catch(console.error)
    this.processing = false

    this.process()
  }

  random([min, max] = this.jitter) {
    return Math.floor(Math.random() * (max - min) + min)
  }
}
